<template>
  <div class="projects-index">
    <!-- Header -->
    <div class="my-3">
      <div v-if="isCXR" class="d-flex flex-row justify-content-start align-items-start">
        <div class="d-flex flex-column flex-fill justify-content-start">
          <h2>Welcome!</h2>
          <p class="m-0">From the listed colleagues below, select who you'd like to meet with to discuss shared interests or career aspirations.</p>
          <p class="m-0">You can search for colleagues by title, name, or expertise to help make the most helpful connections.</p>
        </div>
        <div class="d-flex flex-column justify-content-start">
          <b-btn v-if="mentorStatus" :to="{ name: 'Onboarding' }" variant="primary">Change mentor options</b-btn>
          <b-btn v-else :to="{ name: 'Onboarding' }" variant="primary">Become a mentor</b-btn>
        </div>
      </div>
      <h2 v-else>Mentors</h2>
    </div>

    <mentors-list-container
      :loading="$apollo.loading || !mentors"
      :company="company"
      :mentors="mentors ? mentors.userConnections.edges : null"
      :order="filterMentorsOrder"
      @orderUpdated="filterMentorsOrderUpdated"
      @submitContactMentorRequest="submitContactMentorRequest($event)"
    />

    <cxr-partner-logos v-if="isCXR"/>
  </div>
</template>

<script>
import ms from 'ms';
import enumsMixin from '@src/mixins/enums';
import JobTitleSelector from '@/components/profile/JobTitleSelector';
import JobSkillsSelector from '@/components/profile/JobSkillsSelector';
import MentorsListContainer from '@/components/mentors/MentorsListContainer';
import MentorsListQuery from '@/graphql/queries/MentorsList.gql';
import MentorRequestCreateMutation from '@/graphql/mutations/MentorRequestCreate.gql';
import CxrPartnerLogos from '@/components/success/cxr-partner-logos';
import { mapRoot } from '@src/mixins/root';
import { parseIfPossible, getUserFieldValue } from '@src/lib/imMatching';

export default {
  components: {
    MentorsListContainer,
    JobTitleSelector,
    JobSkillsSelector,
    CxrPartnerLogos,
  },
  mixins: [
    enumsMixin,
  ],
  data: () => ({
    filterMentorsOrder: 'MOST_RELEVANT',
    form: {
      title: '',
      fullName: '',
      skills: [],
    },
  }),
  apollo: {
    mentors: {
      query: MentorsListQuery,
      variables() {
        const { filterMentorsOrder: order } = this;
        return {
          where: {
            mentorStatus: 'ACTIVE',
            status: 'ACTIVE',
          },
          order,
          page: 1,
          limit: 1000,
        };
      },
      update(data) {
        const { company: { userConnections }, user: { mentorRequests } } = data;
        if (userConnections && Array.isArray(userConnections.edges)) {
          userConnections.edges = userConnections.edges.map(el => {
            const mentorRequest = mentorRequests.find(({ mentor: { id: mentorID } }) => mentorID === el.entry.id);
            el.entry.mentorRequest = {};
            if (mentorRequest) {
              el.entry.mentorRequest = mentorRequest;
            }
            return el;
          }).filter(el => {
            const maxMentees = parseIfPossible(getUserFieldValue.call(this, el.entry, 'RANGE', 'mentorship'));
            if (maxMentees && Number.isInteger(maxMentees) && maxMentees > 0 && Array.isArray(el.entry.menteeRequests)) {
              return el.entry.menteeRequests.length < maxMentees;
            }
            return true;
          });
        }
        console.log('MENTOR REQUESTS: ', { mentorRequests });
        console.log('USER CONNECTIONS: ', { userConnections });
        return { userConnections };
      },
      error(err) {
        this.$log.error(err);
      },
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
      deep: true,
      throttle: ms('1s'),
    },
  },
  metaInfo() {
    return {
      title: 'Mentors',
    };
  },
  computed: {
    ...mapRoot([ 'company', 'isLoggedIn', 'isRecruiter', 'user', 'isCXR' ]),
    mentorStatus() {
      const { mentorStatus } = this.user || {};
      return mentorStatus || null;
    },
  },
  methods: {
    filterMentorsOrderUpdated(order) {
      this.filterMentorsOrder = order;
      this.filterMentorsPage = 1;

      this.$scrollTo('body');
    },
    async submitContactMentorRequest(form) {
      const { mentor, form: { message, selectedSkills: skills } } = form;
      const create = {
        message,
        skills,
        mentor: {
          id: mentor.id,
        },
      };
      try {
        await this.$apollo.mutate({
          mutation: MentorRequestCreateMutation,
          variables: { create },
          update: (store, { data: { createMentorRequest } }) => {
            const { filterMentorsOrder: order } = this;
            const data = store.readQuery({
              query: MentorsListQuery,
              variables: {
                where: {
                  mentorStatus: 'ACTIVE',
                  status: 'ACTIVE',
                },
                order,
                page: 1,
                limit: 1000
              }
            });
            if (data && data.user && Array.isArray(data.user.mentorRequests)) {
              data.user.mentorRequests.push(createMentorRequest);
            }
            console.log('DATA: ', data);
            store.writeQuery({ query: MentorsListQuery, data });
          },
        });
        Promise.resolve(this.$root.captureLog({
          eventName: 'IM_NEW_MENTOR_REQUEST',
          user: { id: this.user.id },
          data: [ { key: 'mentorID', value: mentor.id } ],
        }));
      } catch (err) {
        this.$log.error(err);
      }
    }
  },
};
</script>
<style lang="scss">
.page .projects-index {

  h2 {
    margin-bottom: 0.75em;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/mentors/MentorsIndex.vue